import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, MapPin, Building, Mail, Phone } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
import { CTASection } from '../components/CTASection';
import { advisors } from '../data/mockData';
export function AdviseurDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const advisor = advisors.find(a => a.slug === slug) || advisors[0];
  return <div className="w-full bg-offwhite pt-24 pb-24" data-id="element-185">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 pt-8" data-id="element-186">
        <Link to="/adviseurs" className="inline-flex items-center text-sm text-charcoal/60 hover:text-accent transition-colors mb-8" data-id="element-187">
          <ArrowLeft size={16} className="mr-2" data-id="element-188" /> Terug naar overzicht
        </Link>

        <div className="bg-white rounded-3xl shadow-sm border border-warmgray/50 overflow-hidden" data-id="element-189">
          <div className="grid grid-cols-1 lg:grid-cols-12" data-id="element-190">
            {/* Left Col: Info */}
            <div className="lg:col-span-5 p-10 lg:p-12 border-b lg:border-b-0 lg:border-r border-warmgray/50 bg-white" data-id="element-191">
              <AnimatedSection data-id="element-192">
                <div className="w-32 h-32 rounded-full overflow-hidden mb-6 border-4 border-offwhite shadow-sm" data-id="element-193">
                  <img src={advisor.image} alt={advisor.name} className="w-full h-full object-cover" data-id="element-194" />
                </div>
                <h1 className="text-3xl font-light text-charcoal mb-2" data-id="element-195">
                  {advisor.name}
                </h1>

                <div className="space-y-3 mt-6 mb-8" data-id="element-196">
                  <div className="flex items-center gap-3 text-charcoal/70" data-id="element-197">
                    <Building size={18} className="text-accent" data-id="element-198" />
                    <span data-id="element-199">{advisor.company}</span>
                  </div>
                  <div className="flex items-center gap-3 text-charcoal/70" data-id="element-200">
                    <MapPin size={18} className="text-accent" data-id="element-201" />
                    <span data-id="element-202">{advisor.location}</span>
                  </div>
                </div>

                <div className="prose prose-sm text-charcoal/70 mb-8" data-id="element-203">
                  <p data-id="element-204">{advisor.bio}</p>
                </div>

                <div className="pt-8 border-t border-warmgray/50" data-id="element-205">
                  <h3 className="text-sm font-medium text-charcoal mb-4 uppercase tracking-wider" data-id="element-206">
                    Contact via platform
                  </h3>
                  <p className="text-xs text-charcoal/50 mb-4" data-id="element-207">
                    Uw aanvraag wordt direct doorgestuurd naar deze adviseur.
                    Wij monitoren de reactietijd.
                  </p>
                </div>
              </AnimatedSection>
            </div>

            {/* Right Col: Form */}
            <div className="lg:col-span-7 p-10 lg:p-12 bg-offwhite/50" data-id="element-208">
              <AnimatedSection delay={0.2} data-id="element-209">
                <h2 className="text-2xl font-light text-charcoal mb-8" data-id="element-210">
                  Vraag een waardering aan via {advisor.name.split(' ')[0]}
                </h2>

                <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-211">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-212">
                    <div data-id="element-213">
                      <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-214">
                        Naam
                      </label>
                      <input type="text" className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-white" placeholder="Uw naam" data-id="element-215" />
                    </div>
                    <div data-id="element-216">
                      <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-217">
                        Bedrijfsnaam
                      </label>
                      <input type="text" className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-white" placeholder="Uw bedrijf" data-id="element-218" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-219">
                    <div data-id="element-220">
                      <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-221">
                        E-mailadres
                      </label>
                      <input type="email" className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-white" placeholder="email@bedrijf.nl" data-id="element-222" />
                    </div>
                    <div data-id="element-223">
                      <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-224">
                        Telefoonnummer
                      </label>
                      <input type="tel" className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-white" placeholder="06 12345678" data-id="element-225" />
                    </div>
                  </div>

                  <div data-id="element-226">
                    <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-227">
                      Korte toelichting situatie
                    </label>
                    <textarea rows={4} className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-white resize-none" placeholder="Bijv: Ik overweeg mijn bedrijf te verkopen en wil graag een indicatie van de waarde..." data-id="element-228"></textarea>
                  </div>

                  <button type="submit" className="w-full bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-xl text-base font-medium transition-all shadow-subtle" data-id="element-229">
                    Verstuur aanvraag
                  </button>
                  <p className="text-xs text-center text-charcoal/50 mt-4" data-id="element-230">
                    Door dit formulier te versturen gaat u akkoord met ons
                    privacybeleid.
                  </p>
                </form>
              </AnimatedSection>
            </div>
          </div>
        </div>

        {/* Internal Links Section */}
        <AnimatedSection delay={0.3} className="mt-16 max-w-4xl mx-auto" data-id="element-231">
          <div className="bg-white rounded-2xl p-8 border border-warmgray/50 shadow-sm" data-id="element-232">
            <h3 className="text-lg font-medium text-charcoal mb-6" data-id="element-233">
              Meer informatie
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-234">
              <Link to="/bedrijfswaardering" className="flex items-center p-4 rounded-xl bg-offwhite hover:bg-accent hover:text-white transition-colors group" data-id="element-235">
                <span className="font-medium" data-id="element-236">
                  Meer over onze bedrijfswaardering
                </span>
              </Link>
              <Link to="/kennisbank/bedrijfswaardering/hoe-werkt-een-bedrijfswaardering" className="flex items-center p-4 rounded-xl bg-offwhite hover:bg-accent hover:text-white transition-colors group" data-id="element-237">
                <span className="font-medium" data-id="element-238">
                  Hoe werkt een bedrijfswaardering?
                </span>
              </Link>
            </div>
          </div>
        </AnimatedSection>
      </div>

      <CTASection data-id="element-239" />
    </div>;
}